import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import AppStore from "../../config/AppStore";
import { sendRequestGetPublishers } from "../../view_logics/Publishers";
import { setUserType } from "../../view_logics/LoginSlice";
import PublishersApprovedModel from "./PublishersApprovedModel";

const PublishersList = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [publisherId, setPublisherId] = useState(null);

  const { userType, mainUser } = useSelector(state => state?.login);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const store = AppStore.getAppStoreInstance();
  const accessToken = store.getState().login.accessToken;

  const inputObj = {
    accessToken,
    url: "editPublisher",
    history: navigate,
    data: [],
    dataHander: setData,
  };

  // ✅ Extracted fetch function for reuse
  const fetchPublishersList = async () => {
    try {
      await sendRequestGetPublishers({
        ...inputObj,
        dataHander: (res) => {
          setData(res);
          setFilteredData(res);
        }
      });
    } catch (error) {
      console.log("Error fetching data:", error);
    }
  };

  // Initial fetch
  useEffect(() => {
    fetchPublishersList();
  }, []);

  const editPublisherHandler = (item) => {
    const url = '/publishers/edit/' + item.id;
    navigate(url);
  };

  const changeUserType = (publisher) => {
    dispatch(setUserType({
      type: "publisher",
      id: publisher.id,
      publisherCompany: publisher.company_name,
      publisherName: `${publisher.first_name} ${publisher.last_name}`
    }));
    navigate('/dashboard');
  };

  const [selectedPublisher, setSelectedPublisher] = useState("all");
  const publisherChangeHandler = (e) => {
    setSelectedPublisher(e.target.value);
  };

  const applyFilterHandler = () => {
    
    if (selectedPublisher === 'pending') {
      setFilteredData(data.filter(item => item.status === 'pending'));
    } else if (selectedPublisher === 'active') {
      setFilteredData(data.filter(item => (item.is_active === 1 && item.status != 'pending') ));
    } else if (selectedPublisher === 'inactive') {
      setFilteredData(data.filter(item => (item.is_active === 0 && item.status != 'pending') ));
    } else {
      setFilteredData(data);
    }
  };

  // ✅ Called by child when a publisher is approved
  const handlePublisherApproved = (approvedId) => {
    console.log("Publisher approved:", approvedId);
    setSelectedPublisher("all");
    fetchPublishersList(); // refresh entire list
  };

  return (
    <>
    <PublishersApprovedModel 
        publisherId={publisherId} 
        isVisible="true" 
        onApproved={handlePublisherApproved}
      />
    
    <div className="col-12 col-xl-12" Style="overflow-x: auto;display: block;">
      

      <div className="card">
        {userType === "admin" && (
          <>
            <div className="col-sm-6 d-flex align-items-center pt-3 px-2 gap-2">
              <div className="d-flex w-75 gap-1 align-items-center">
                <label className="form-label mb-0" htmlFor="advertiserId">
                  Publisher:
                </label>
                <select
                  className="form-select"
                  value={selectedPublisher}
                  onChange={publisherChangeHandler}
                >
                  <option value="all">Select all</option>
                  <option value="active">Active</option>
                  <option value="inactive">Disabled</option>
                  <option value="pending">Pending</option>
                </select>
              </div>
              <button
                type="button"
                className="btn btn-primary"
                onClick={applyFilterHandler}
                disabled={!selectedPublisher}
              >
                Apply
              </button>
            </div>
            <hr />
          </>
        )}

        <table className="table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Company</th>
              <th>Email</th>
              <th>Contact Number</th>
              <th>Contact Name</th>
              <th>Revenue share</th>
              <th>Status</th>
              <th>Actions</th>
              {mainUser === "admin" && <th style={{ width: '140px' }}></th>}
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((publisher, index) => (
                <tr
                  key={publisher.id}
                  className={
                    publisher.is_active === 0
                      ? "table-secondary"
                      : index % 2 === 0
                        ? "table-success"
                        : ""
                  }
                >
                  <td>{publisher.id}</td>
                  <td>{publisher.company_name}</td>
                  <td>{publisher.email}</td>
                  <td>{publisher.phone || "N/A"}</td>
                  <td>{`${publisher.first_name} ${publisher.last_name}`}</td>
                  <td>{`${publisher.revenue_share}/${100 - publisher.revenue_share}`}</td>
                  <td>
                    {publisher.status === 'pending'
                      ? "Pending"
                      : publisher.is_active === 1
                        ? "Active"
                        : "Disabled"}
                  </td>
                  <td>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        editPublisherHandler(publisher);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-edit-2 align-middle"
                      >
                        <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
                      </svg>
                    </a>
                  </td>
                  {mainUser === "admin" && (
                    <td>
                      {publisher.status === 'pending' ? (
                        <button
                          type="button"
                          onClick={() => setPublisherId(publisher.id)}
                          className="btn btn-outline-secondary btn-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#publishers_approved_model"
                        >
                          Approve
                        </button>
                      ) : publisher.is_active === 1 ? (
                        <button
                          type="button"
                          className="btn btn-secondary btn-sm"
                          onClick={() => changeUserType(publisher)}
                        >
                          Act as Publisher
                        </button>
                      ) : null}
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9">Loading data...</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    </>
  );
};

export default PublishersList;
